import { observer } from 'mobx-react-lite'
import { SelectValueDropdown } from 'pages/chatbot/pages/agentBookAppointment/pages/connectCalendar/ui/SelectValueDropdown'
import { LinkTriggerContent } from 'pages/chatbot/pages/agentBookAppointment/pages/connectCalendar/ui/LinkTriggerContent'
import { GoogleCalendarDropdownCustomComponent } from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/ui/GoogleCalendarDropdownCustomComponent/GoogleCalendarDropdownCustomComponent'
import type { GoogleCalendarPickerStore } from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/store/googleCalendarPickerStore'
import styles from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/styles.module.scss'

type IBookingStepGoogleCalendarProps = {
  googleCalendarPickerStore: GoogleCalendarPickerStore
  onSelectCalendar: () => void
}

export const BookingStepGoogleCalendar = observer(
  ({ googleCalendarPickerStore, onSelectCalendar }: IBookingStepGoogleCalendarProps) => {
    const { loading, selectedCalendarItem, googleCalendarError, resetError } =
      googleCalendarPickerStore

    return (
      <div className={styles.list}>
        <SelectValueDropdown
          placeholder={'Select calendar'}
          isValueSelected={!!selectedCalendarItem}
          isLoading={loading}
          errorMessage={googleCalendarError}
          ariaLabel={'SelectGoogleCalendarWidget'}
          triggerContent={<LinkTriggerContent link={selectedCalendarItem} />}
          placement={'top-start'}
          customComponent={(onClose) => (
            <GoogleCalendarDropdownCustomComponent
              googleCalendarPickerStore={googleCalendarPickerStore}
              onClose={onClose}
              onSelectCalendar={onSelectCalendar}
              isTopReverse
            />
          )}
          width={482}
          removeError={() => resetError('googleCalendarError')}
        />
      </div>
    )
  }
)
